
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.861 11.733c.152-.386.475-.733.889-.733a.75.75 0 00.75-.75v-1a.25.25 0 00-.25-.25.25.25 0 01-.25-.25V7.303a1 1 0 00-.168-.555l-1.535-2.303A1 1 0 0019.465 4H12.03a1 1 0 00-.467.116L8.219 5.884A1 1 0 017.752 6H3.618a1 1 0 00-.894.553L2.17 7.658A.618.618 0 011.618 8 .618.618 0 001 8.618V10a1 1 0 001 1c.552 0 .98.475 1.244.959a2 2 0 003.512 0C7.02 11.475 7.448 11 8 11h8c.552 0 .98.475 1.244.959a2 2 0 003.617-.226zm-8.976-6.667l-1.75 1C9.69 6.32 9.87 7 10.383 7h2.727a.5.5 0 00.485-.379l.25-1A.5.5 0 0013.36 5h-1.227a.5.5 0 00-.248.066zm3.02.313l-.25 1A.5.5 0 0015.14 7h.97a.5.5 0 00.485-.379l.25-1A.5.5 0 0016.36 5h-.97a.5.5 0 00-.485.379zm2.75 1l.25-1A.5.5 0 0118.39 5h.72a.5.5 0 01.485.379l.25 1A.5.5 0 0119.36 7h-1.22a.5.5 0 01-.485-.621z","fill":"currentColor"}})])
          )
        }
      }
    